import createEscaper from './_createEscaper.js';
import escapeMap from './_escapeMap.js';

// Function for escaping strings to HTML interpolation.
export default createEscaper(escapeMap);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/escape.js
// module id = 835
// module chunks = 115